module.exports = __webpack_public_path__ + "static/media/guadalupe_doradaextrablanca.c0544845.png";